import { format, parse } from "date-fns";
import { Typography } from "@mui/material";

import type { ItemList } from "../inventory/types";

/** Global config stores numeric settings as strings; toFixed needs a finite integer 0–100. */
export function quantityDecimalPlaces(
  globalConfig?: { quantity_rounding?: unknown }
): number {
  const raw = Number(globalConfig?.quantity_rounding ?? 2);
  if (!Number.isFinite(raw) || raw < 0) {
    return 2;
  }
  return Math.min(100, Math.floor(raw));
}

export function getStockItemOwnerName(item: ItemList): string | null {
  if (Number(item.owner_id) > 0 && item.owner?.name) {
    return item.owner.name;
  }
  return null;
}

export function StockItemOwnerLine({ item }: { item: ItemList }) {
  const ownerName = getStockItemOwnerName(item);
  if (!ownerName) {
    return null;
  }

  return (
    <div>
      <b>Owner:</b> {ownerName}
    </div>
  );
}

export interface StockItemOptionDetailsProps {
  item: ItemList;
  dateFormat?: string;
  quantityRounding?: number;
}

export function StockItemOptionDetails({
  item,
  dateFormat,
  quantityRounding = 2,
}: StockItemOptionDetailsProps) {
  const formattedExpiry =
    item.shelf_expiry && dateFormat
      ? format(parse(item.shelf_expiry, "yyyy-MM-dd", new Date()), dateFormat)
      : item.shelf_expiry ?? "";

  return (
    <Typography component="div" variant="body2">
      <div>
        <b>Item Number: {item.id}</b>
      </div>
      <div>
        <b>Batch#:</b> {item.batch?.number} / <b>Expiry Date:</b>{" "}
        {formattedExpiry}
      </div>
      <div>
        <b>Location:</b> {item.location} / <b>Store:</b> {item.store}{" "}
        <b>Shelf:</b> {item.shelf}
      </div>
      <div>
        <b>Quantity:</b> {Number(item.quantity).toFixed(quantityRounding)} /{" "}
        <b>Condition:</b> {item.condition}
      </div>
      <div>
        <b>Serial#:</b> {item.serial_number} / <b>Notes:</b> {item.notes}
      </div>
      <StockItemOwnerLine item={item} />
    </Typography>
  );
}
